import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-user-management-parent',
    templateUrl: './user-management-parent.component.html',
    styleUrls: ['./user-management-parent.component.scss'],
    standalone: false
})
export class UserManagementParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
